// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LIKE = "P\u00e1\u010di sa mi to";
export const UNLIKE = "U\u017e sa mi to nep\u00e1\u010di";
